import * as React from 'react';
import WizardCard from '../../components/WizardCard/WizardCard';
import Appear from '../../components/Appear/Appear';
import withContainer from '../../containers/WithContainer';
import { ContainerNew } from '../../containers/AppContainer';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import classnames from 'classnames';

interface ProfilePicProps extends RouteComponentProps {
  appContainer: ContainerNew;
}
class ProfilePic extends React.Component<ProfilePicProps, any> {
  constructor(props: any) {
    super(props);
  }
  app = this.props.appContainer;

  handleFileRead = (content: any) => {
    this.app.setProfileImageUrl(content);
  };

  handleUploadChange = async (evt: any) => {
    const file = evt.target.files[0];
    this.app.setProfileImageUrl(URL.createObjectURL(file));
    this.setState({
      uploadedImg: URL.createObjectURL(file),
    });
    this.props.appContainer.step2imageUpload(file, this.getCurrStep());
  };

  onNext = () => {
    console.log('submit profile pic');
    this.props.appContainer.updateProfileImage(this.getCurrStep());
  };

  getCurrStep = () => {
    let step = parseInt(this.props.match.path.split('-')[1]);
    return step;
  };

  render() {
    return (
      <WizardCard
        duration={0.5}
        delay={1.5}
        title="Add your profile photo"
        subTitle={
          <div>
            Clients like booking real people.
            <br /> Upload a picture of you that clearly shows your face.{' '}
          </div>
        }
        isDisabled={!this.app.state.step2.profile_image}
        onNext={this.onNext}
      >
        <Appear duration={0.5} delay={1}>
          <div className="level has-margin-top-30">
            <div className="level-item">
              {!this.props.appContainer.state.step2.profile_image && (
                <>
                  <div className="flex flex-column">
                    <div className="has-text-centered has-text-weight-bold has-text-grey">
                      Example:
                    </div>
                    <figure className="image is-96x96 has-margin-top-10">
                      <img
                        src="/img/profilePic.jpg"
                        alt="profile picture"
                        className="is-rounded is-covering-container"
                      />
                    </figure>
                  </div>
                </>
              )}

              {!!this.props.appContainer.state.step2.profile_image && (
                <Appear duration={0.5}>
                  <figure className="image is-96x96">
                    <img
                      src={this.props.appContainer.state.step2.profile_image}
                      alt="profile picture"
                      className="is-rounded is-covering-container"
                    />
                  </figure>
                </Appear>
              )}
            </div>
          </div>
          <div className="file level-item">
            <label className="file-label">
              <input
                className="file-input"
                type="file"
                name="profilePic"
                onChange={this.handleUploadChange}
                accept="image/*"
              />
              <span
                className={classnames({
                  'upload-button button is-full-width is-primary': !this.app
                    .state.step2.profile_image,
                })}
              >
                <span className="file-label">
                  {this.app.state.step2.profile_image
                    ? 'Change Photo'
                    : 'Upload Your Selfie'}
                </span>
              </span>
            </label>
          </div>
        </Appear>
      </WizardCard>
    );
  }
}

export default withRouter(withContainer(ProfilePic));
